import { render } from "./DepotCardDetail.vue?vue&type=template&id=7811e932&scoped=true"
import script from "./DepotCardDetail.vue?vue&type=script&lang=js"
export * from "./DepotCardDetail.vue?vue&type=script&lang=js"

import "./DepotCardDetail.vue?vue&type=style&index=0&id=7811e932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7811e932"]])

export default __exports__